import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Seo from "@/components/seo/Seo";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <Seo
        title="Страница не найдена — ЖИВАРУС"
        description="К сожалению, запрошенная страница не существует. Вернитесь на главную сайта ЖИВАРУС."
        canonicalPath={location.pathname}
        noindex
      />
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Страница не найдена</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Вернуться на главную
        </a>
      </div>
    </div>
  );
};

export default NotFound;
